import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import {
  Grid, Dropdown, Loader,
} from 'semantic-ui-react';
import { debounce } from 'lodash';
import findResult, { hasKey } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import { dropdownTypes } from '../constants';
import { updateFilterValues, performFacetedSearch } from '../searchHelper';

const FacetDropdowns = ({
  code,
  category,
  facets,
  filter,
  searchConfig,
  searchConfigStatus,
  updateFilters,
  canUpdate,
  performSearch,
}) => {
  const debounceSearch = useMemo(() => debounce(performSearch, 500), [performSearch]);

  const buildOption = (value) => (
    {
      value,
      key: value,
      text: value,
    }
  );

  const getOptions = (facetKey) => {
    if (canUpdate) {
      return facets[facetKey].map((x) => (
        buildOption(x.value)
      ));
    }

    return filter[facetKey]?.map((x) => (
      buildOption(x)
    ));
  };

  const handleDropdownFilterChange = (e, data) => {
    const { name, value } = data;
    const newFilters = { ...filter };

    newFilters[name] = value;
    updateFilters(category, code, newFilters, name);
    debounceSearch(category, code);
  };

  const isLoadingConfig = searchConfigStatus === states.PENDING;

  const isValidDropdownType = (type) => (dropdownTypes.includes(type));
  const hasFacetValues = (facetName) => (facets && hasKey(facets, facetName) && facets[facetName].length > 0);
  const hasFilterValues = (facetName) => (hasKey(filter, facetName) && filter[facetName].length > 0);
  const canDisplayDropdown = (facetConfig) => (isValidDropdownType(facetConfig.type) && facetConfig.enabled_dropdown
  && hasFacetValues(facetConfig.name) && (canUpdate || hasFilterValues(facetConfig.name)));

  return (
    <Grid centered columns="equal">
      {isLoadingConfig && <Loader active inline="centered" size="tiny" />}
      {
          searchConfig.facets.map((facetConfig) => (
            canDisplayDropdown(facetConfig) && (
              <Grid.Column key={facetConfig.name} textAlign="center">
                <Dropdown
                  multiple
                  selection
                  labeled
                  floating
                  button
                  className="icon aridhia-search-facet-dropdown max-content"
                  icon="filter"
                  name={facetConfig.name}
                  text={facetConfig.label}
                  options={getOptions(facetConfig.name)}
                  onChange={canUpdate && (handleDropdownFilterChange)}
                  disabled={!canUpdate}
                  value={filter[facetConfig.name] || []}
                />
              </Grid.Column>
            )
          ))
        }
    </Grid>
  );
};

const mapStateToProps = ({
  search: { searches, searchConfig },
}, { category, code }) => {
  const item = findResult(searches, category, code);
  return (
    {
      facets: item?.facets || {},
      filter: item?.filter || {},
      searchStatus: item?.searchStatus || states.NONE,
      searchConfigStatus: searchConfig?.readStatus || states.NONE,
      searchConfig: searchConfig?.config || {},
      canUpdate: item?.permissions?.can_update,
    }
  );
};

const mapDispatchToProps = {
  updateFilters: updateFilterValues,
  performSearch: performFacetedSearch,
};

export default connect(mapStateToProps, mapDispatchToProps)(FacetDropdowns);
